import * as zDate from "./date";
import { buildUTCString } from "./dateTime";

// tslint:disable-next-line:no-namespace
declare global {

    interface DateConstructor {
        nowDateString(): string;
        nowDateTimeString(): string;
    }

    interface Date {
        addHours(h): Date;
        addMinutes(m): Date;
        addSeconds(s): Date;
        addMilliseconds(s): Date;
        addDays(d): Date;
        subtractDays(d): Date;
        dayDiff(d): number;
        hourDiff(d): number;
        minDiff(d): number;
        clone(): Date;
    }

    interface String {
        dayDiff(date): number;
    }

}

Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
};

Date.prototype.addMinutes = function (m) {
    this.setMinutes(this.getMinutes() + m);
    return this;
};

Date.prototype.addDays = function (d) {
    this.setDate(this.getDate() + d);
    return this;
};

Date.prototype.addSeconds = function (s) {
    this.setSeconds(this.getSeconds() + s);
    return this;
};

Date.prototype.addMilliseconds = function (m) {
    this.setMilliseconds(this.getMilliseconds() + m);
    return this;
};

Date.prototype.subtractDays = function (d) {
    this.setDate(this.getDate() - d);
    return this;
};

Date.prototype.dayDiff = function (d) {
    // Round to nearest number of days because of hour lost/gained for daylight savings time
    return Math.round((d - this) / (1000 * 60 * 60 * 24));
};

Date.prototype.hourDiff = function (d) {
    return ((d - this) / (1000 * 60 * 60));
};

Date.prototype.minDiff = function (d) {
    return ((d - this) / (1000 * 60));
};

Date.prototype.clone = function () {
    return new Date(this.getTime());
};

Date.nowDateString = function () {
    return kendo.toString(new Date(), "yyyy-MM-dd") + "T00:00:00Z";
};

Date.nowDateTimeString = function () {
    return buildUTCString(new Date());
};

String.prototype.dayDiff = function (date) {
    var thisDate = zDate.date(this);

    date = zDate.date(date);

    return thisDate.dayDiff(date);
};
